import * as React from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    H2Emphasized,
    SafeAreaView,
    YStack,
} from 'smoothie';

import Logo from '../../../assets/images/logos/fruitful-logo-icon-only.svg';
import { IS_PRODUCTION } from '../../config/FruitfulEnvironment';
import usePlaidOAuthTestTrigger from '../hooks/usePlaidOAuthTestTrigger';

const PlaidOAuthTest = () => {
    const { mutateAsync: plaidOAuthTestTrigger } = usePlaidOAuthTestTrigger();

    const handlePlaidOAuthTestTriggerRedirect = async () => {
        const { redirectUri } = await plaidOAuthTestTrigger({
            body: {},
        });

        window.location.href = redirectUri;
    };
    if (IS_PRODUCTION) {
        throw new Error(
            'PlaidOAuthTest should never be rendered in production',
        );
    }

    return (
        <SafeAreaView style={{ flex: 1 }}>
            <YStack
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
            >
                <YStack
                    alignItems="center"
                    gap={20}
                    padding={20}
                    width="100%"
                    maxWidth={500}
                >
                    <Logo width={32} height={28} />
                    <H2Emphasized textAlign="center">
                        Test Plaid Core Exchange (OAuth) flow
                    </H2Emphasized>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Simulate Plaid OAuth flow"
                        onPress={handlePlaidOAuthTestTriggerRedirect}
                    />
                </YStack>
            </YStack>
        </SafeAreaView>
    );
};

export default PlaidOAuthTest;
